import { useState } from 'react';
import { useSelector } from 'react-redux';
import parsePhoneNumber from 'libphonenumber-js';

import withFormField from './withFormField';
import withFormikInput from './withFormikInput';

import { selectDealershipSettings } from 'services/DealershipSettings/selectors';

import { PhoneFieldInput } from 'components/Inputs/Inputs.styles';

const _PhoneInput = (props) => {
  const settings = useSelector(selectDealershipSettings());
  const [localValue, setLocalValue] = useState(props.value);

  const handleChange = (phone) => {
    const phoneNumber = parsePhoneNumber(phone);

    if (phoneNumber) {
      const simulatedEventPayload = {
        target: {
          name: props.name,
          value: phoneNumber && phoneNumber.number,
        },
      };

      props.onChange(simulatedEventPayload);
    }

    setLocalValue(phone);
  };

  return (
    <PhoneFieldInput
      {...props}
      defaultCountry={settings.get('country').toLowerCase()}
      value={localValue}
      onChange={handleChange}
    />
  );
};

const FormPhoneInput = withFormikInput(withFormField(_PhoneInput));
export default FormPhoneInput;
